<router-outlet />
@if (isLoading) {
  <div class="loader-background">
    <app-foodback-loader
      variant="page"
      [container]="false"
      [color]="'var(--fb-on-brand-navy)'"
      label="Warming up…" />
  </div>
}
